export default __webpack_public_path__ + "static/media/learn2Guide.40f435d8.png";